import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    latestCandidates: null,
    loading: false,
};
export var v3company = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
